import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCameraRetro } from "@fortawesome/free-solid-svg-icons";
import { Alert, Snackbar } from "@mui/material";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";
import { addclub, troomlist } from "../../components/funtionsBD/Mainservice";
import { AddHeader } from "../../components/AddHeader";
import ClubLogoMark from "../../components/ClubLogoMark";
import { useNavigate } from "react-router-dom";
import { CLUB_COUNTRIES, normalizeClubCountry } from "../../constants/countries";

export const AddClub = () => {
  const [pictures, setPictures] = useState([]);
  const [imgvalue, setimgvalue] = useState();
  const [Type, setType] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [success, setsuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const Navigate = useNavigate();

  const validate = (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = `${t("require")}`;
    } else if (values.name.length > 100) {
      errors.name = `${t("must")}`;
    }

    if (!values.email) {
      errors.email = `${t("require")}`;
    }
    if (!values.address) {
      errors.address = `${t("require")}`;
    }
    if (!values.country) {
      errors.country = `${t("require")}`;
    }
    if (!values.troom) {
      errors.troom = `${t("require")}`;
    }
    if (!values.table) {
      errors.table = `${t("require")}`;
    }

    return errors;
  };

  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    setimgvalue(e.target.value);
    setPictures(file);
    formik.setFieldValue("img", URL.createObjectURL(file));
  };

  const handleadd = async (values, { resetForm }) => {
    try {
      const payload = {
        ...values,
        country: normalizeClubCountry(values.country),
      };
      const response = await addclub(pictures, payload);
      setsuccess(response.data.message);
      setOpen(true);
      resetForm();
      setimgvalue("");
      Navigate("/Club");
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      img: "",
      troom: "",
      address: "",
      table: "",
      country: "LU",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      handleadd(values, { resetForm });
    },
  });

  return (
    <div id="adminRoot">
      <AddHeader title={t("addclub")} />

      <form className="add-exercise" onSubmit={formik.handleSubmit}>
        <div className="edit-pic">
          {formik.values.img ? (
            <img src={formik.values.img} alt="" />
          ) : (
            <ClubLogoMark useBrandFallback size="lg" />
          )}
          <label htmlFor="img" className="edit-img-label">
            <FontAwesomeIcon icon={faCameraRetro} className="edit-camera" />
          </label>
        </div>
        <input
          className="input_addpicsvg"
          type="file"
          name="img"
          value={imgvalue}
          id="img"
          accept="image/*"
          onChange={handleFileInputChange}
        />
        <div className="input-details">
          <div className="input-detail">
            <label htmlFor=""> {t("clubname")}</label>
            <input
              placeholder={t("writename")}
              type="text"
              value={formik.values.name}
              name="name"
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.name ? (
            <div className="validation_error">{formik.errors.name}</div>
          ) : null}

          <div className="input-detail">
            <label htmlFor=""> {t("mail")}</label>
            <input
              type="email"
              placeholder={t("enteremail")}
              value={formik.values.email}
              onChange={formik.handleChange}
              name="email"
            />
          </div>

          {formik.errors.email ? (
            <div className="validation_error">{formik.errors.email}</div>
          ) : null}

          <div className="input-detail">
            <label htmlFor="country">{t("country") || "Country"}</label>
            <select
              id="country"
              name="country"
              value={formik.values.country}
              onChange={formik.handleChange}
            >
              <option value="">{t("selectCountry") || "Select Country"}</option>
              {CLUB_COUNTRIES.map((c) => (
                <option key={c.code} value={c.code}>
                  {c.name} ({c.code})
                </option>
              ))}
            </select>
          </div>
          {formik.errors.country ? (
            <div className="validation_error">{formik.errors.country}</div>
          ) : null}

          <div className="input-detail">
            <label htmlFor=""> {t("traningroom")}</label>
            <input
              placeholder={t("traningroom")}
              type="text"
              value={formik.values.troom}
              name="troom"
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.troom ? (
            <div className="validation_error">{formik.errors.troom}</div>
          ) : null}
          <div className="input-detail">
            <label htmlFor=""> {t("address")}</label>
            <input
              placeholder={t("address")}
              type="text"
              value={formik.values.address}
              name="address"
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.address ? (
            <div className="validation_error">{formik.errors.address}</div>
          ) : null}
          <div className="input-detail">
            <label htmlFor=""> {t("notable")}</label>
            <input
              placeholder={t("notable")}
              type="number"
              value={formik.values.table}
              name="table"
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.table ? (
            <div className="validation_error">{formik.errors.table}</div>
          ) : null}
        </div>

        <div className="input-detail">
          <button className="w-100" type="submit">
            {t("createclub")}
          </button>
        </div>
        <Snackbar
          open={open}
          autoHideDuration={3000}
          onClose={closealert}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert variant="filled" severity="success">
            {success}
          </Alert>
        </Snackbar>
      </form>
    </div>
  );
};
